export function isTruthySetting(value, fallback = true) {
  if (value === null || value === undefined || value === "") {
    return fallback;
  }

  if (typeof value === "boolean") {
    return value;
  }

  return ["1", "true", "yes", "on"].includes(String(value).trim().toLowerCase());
}

export function resolveFeatureSections(settings = {}, defaults = {}) {
  const fallbackProducts = isTruthySetting(
    settings?.products_enabled ?? settings?.productsEnabled,
    true
  );

  const fallback = {
    products: fallbackProducts,
    physicalProducts: fallbackProducts,
    digitalProducts: fallbackProducts,
    courses: true,
    consultations: true,
    services: true,
    jobs: true,
    sellerMarketplace: true,
    aiChat: true,
    ...defaults,
  };

  const physicalProducts = isTruthySetting(
    settings?.physical_products_enabled ?? settings?.physicalProductsEnabled,
    fallback.physicalProducts
  );
  const digitalProducts = isTruthySetting(
    settings?.digital_products_enabled ?? settings?.digitalProductsEnabled,
    fallback.digitalProducts
  );

  return {
    products: physicalProducts || digitalProducts,
    physicalProducts,
    digitalProducts,
    courses: isTruthySetting(settings?.courses_enabled ?? settings?.coursesEnabled, fallback.courses),
    consultations: isTruthySetting(
      settings?.consultations_enabled ?? settings?.consultationsEnabled,
      fallback.consultations
    ),
    services: isTruthySetting(settings?.services_enabled ?? settings?.servicesEnabled, fallback.services),
    jobs: isTruthySetting(settings?.jobs_enabled ?? settings?.jobsEnabled, fallback.jobs),
    sellerMarketplace: isTruthySetting(
      settings?.seller_marketplace_enabled ?? settings?.sellerMarketplaceEnabled,
      fallback.sellerMarketplace
    ),
    aiChat: isTruthySetting(
      settings?.ai_chat_enabled ?? settings?.aiChatEnabled,
      fallback.aiChat
    ),
  };
}

export function isProviderRoleEnabled(role, sections) {
  const map = {
    trainer: sections.courses,
    consultant: sections.consultations,
    freelancer: sections.services,
    employer: sections.jobs,
    seller: sections.sellerMarketplace,
  };

  return map[role] ?? true;
}

export function shouldShowProviderRole(role, sections, profiles = [], currentRole = "") {
  return (
    isProviderRoleEnabled(role, sections) ||
    profiles.some((profile) => profile.providerRole === role) ||
    currentRole === role
  );
}
